export const getNowInSeconds = () => Math.floor(Date.now() / 1000);
